import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../../Assets/css/Login.css";
import "./login.css";
import Cover from "../../Images/cover.png";
import Cover2 from "../../../Assets/img/default-cover-image.svg";
import axios from "axios";
import store from "store";
import Loader from "../../../Components/MainLayout/Loader";
const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class LoginV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPasswordVisible: false,
      values: {
        contact: "",
        password: "",
      },
      schooldata: [],
      loading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "SchoolApp | Login";
    this.fetch({ api_url: axios.defaults.baseURL });
  }

  fetch = (params = {}) => {
    axios
      .get("/api/schoolinfo", {
        params: { ...params },
        type: "json",
        headers: {
          Authorization: ``,
        },
      })
      .then((res) => {
        this.setState({ schooldata: res.data[0] }, () => {});
        store.set("session", res.data[0].session[0]);
        store.set("school_info", res.data[0]);
      });
  };

  fetchSession = (params = {}) => {
    axios.get(`/api/session`, { params: { ...params } }).then((res) => {
      store.set("session", res.data[0]);
    });
  };

  handleInputChange = (e) => {
    this.setState({
      values: { ...this.state.values, [e.target.name]: e.target.value },
    });
  };

  onFinish = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "user/LOGIN",
      payload: this.state.values,
    });
  };

  TogglePassword = () => {
    this.setState((prevState) => ({
      isPasswordVisible: !prevState.isPasswordVisible,
    }));
  };

  render() {
    const { schooldata } = this.state;
    const { isPasswordVisible } = this.state;
    return (
      <div>
        <div
          className="th-login-cover"
          style={{
            backgroundImage: `url(${
              schooldata?.dashboard_bg ? schooldata?.dashboard_bg : Cover2
            })`,
          }}
        ></div>

        <div
          style={{
            zIndex: 10,
          }}
          className="container th-login-container  th-bg-white"
        >
          <div className="flex-column mx-auto py-2">
            <div className="mx-auto px-auto th-24">
              <div className="rounded">
                <div
                  className="th-login-profile"
                  style={{
                    backgroundImage: `url(${
                      schooldata.logo ? schooldata.logo : Cover
                    })`,
                  }}
                ></div>
              </div>
            </div>
            <span className="th-12 th-medium pl-0">
              <p className="mb-0 text-center th-24 th-fw-700 th-black">
                {schooldata.school_name}
              </p>
              <p className="mb-0 th-black text-center th-12 pt-2">
                {schooldata.school_address}
              </p>
            </span>
          </div>
          {/* <div className="th-26 th-fw-400 th-medium th-black mt-4">Hi User</div>
          <div className="th-18 th-medium th-grey">Sign in to continue</div> */}
          <form onSubmit={this.onFinish} className="pt-4">
            <div className="input-group input-group pb-2 flex-column">
              <span className="th-16 th-grey pb-1">Username</span>
              <input
                style={{ fontSize: "16px" }}
                className="form-control w-100 th-br-8 p-4"
                name="contact"
                type="text"
                value={this.state.contact}
                onChange={this.handleInputChange}
                placeholder="Username"
              ></input>
            </div>
            <div className="input-group input-group pb-3 pt-3 flex-column">
              <span className="th-16 th-grey pb-1">Password</span>
              <input
                style={{
                  fontSize: "16px",
                }}
                className="form-control w-100 th-br-8 p-4 "
                name="password"
                type={isPasswordVisible ? "text" : "password"}
                value={this.state.password}
                onChange={this.handleInputChange}
                placeholder="Password"
              />
              <i
                className={
                  isPasswordVisible
                    ? "fa fa-eye th-16 th-primary"
                    : "fa fa-eye-slash th-16 th-primary"
                }
                style={{
                  position: "absolute",
                  marginLeft: "90%",
                  marginTop: "48px",
                  zIndex: "10",
                }}
                onClick={this.TogglePassword}
              ></i>
            </div>
            <div className="d-flex justify-content-between">
              <button
                type="submit"
                className="py-3 mt-4 mb-3 th-white th-br-12 th-16 d-flex"
                style={{
                  background:
                    "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
                  border: "0px",
                  width: "100%",
                }}
              >
                <div className="mx-auto">SIGN IN</div>
                <div className="fa fa-arrow-right pr-3 my-auto"></div>
              </button>
              <div className="my-auto">
                {this.state.loading && !this.props.user.wrong ? (
                  <div className="px-1">
                    <Loader />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="d-flex justify-content-end th-black">
              <Link
                className="th-primary th-bold"
                style={{
                  textDecoration: "none",
                }}
                to="/forgotpassword"
              >
                Forgot password?
              </Link>
            </div>
            <div className="d-flex justify-content-center th-black mt-5 pb-4">
              <a href="https://gungunerp.com/">
                <div className="th-14 th-bold">
                  Powered By :{" "}
                  <span className="th-primary">
                    Gungun Erp Solution Pvt. Ltd.
                  </span>
                </div>
              </a>
            </div>
            {this.props.user.wrong ? (
              <div className="d-flex justify-content-center mt-4 pb-4 th-black">
                <h4 className="th-16 th-black">
                  Username And Password Invalid
                </h4>
              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(LoginV2);
